export type SearchValues = Record<string, string | string[] | undefined>;
export function searchValues(values: SearchValues): Record<string, string | undefined> {
  return Object.fromEntries(
    Object.entries(values).map(([key, value]) => [
      key,
      Array.isArray(value)
        ? ["repository", "type", "review", "tags"].includes(key)
          ? value.join(",")
          : value.at(-1)
        : value,
    ]),
  );
}

export function queryHref(
  path: string,
  current: URLSearchParams,
  changes: Record<string, string | null>,
) {
  const next = new URLSearchParams(current);
  for (const [key, value] of Object.entries(changes)) {
    if (value === null) next.delete(key);
    else next.set(key, value);
  }
  return `${path}${next.size ? `?${next}` : ""}`;
}

export function returnPath(value: unknown) {
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    /[\\\u0000-\u0020]/.test(value)
  )
    return "/";
  const url = new URL(value, "https://workspace.local");
  if (url.origin !== "https://workspace.local" || /^\/(login|api)(\/|$)/.test(url.pathname))
    return "/";
  return url.pathname + url.search + url.hash;
}
